/**
 * NextInputQuestion — 결정트리가 글로 답하는 질문(상품 설명 등)에서 멈췄을 때, 지도 아래 접힘에만 있던 입력 칸을
 *   카드의 '다음 질문' 자리에 올린다(2026-10-14). 완성품/부분품 질문이 남아 있으면 그것을 먼저 보이고 이 칸은 숨긴다.
 *   저장은 기존 입력 칸과 같은 키(예: product_description)로 기록되어 다시 계산한다. 비우고 저장하면 답을 지운다.
 */
import { useEffect, useState } from "react";
import { articleRoleQuestion } from "./ArticleRoleNext";

/** 아직 답하지 않은 첫 입력 질문 — 상품 설명을 먼저. */
export function nextInput(tree, inputs) {
  if (!tree || tree.action !== "ask") return null;
  if (articleRoleQuestion(tree)) return null;
  const open = (Array.isArray(inputs) ? inputs : []).filter((q) => q && q.key && !q.answer);
  if (!open.length) return null;
  return open.find((q) => q.key === "product_description") || open[0];
}

export default function NextInputQuestion({ tree, inputs, onAnswer, disabled = false }) {
  const q = nextInput(tree, inputs);
  const [text, setText] = useState("");
  useEffect(() => { setText(""); }, [q && q.key]);
  if (!q || !onAnswer) return null;
  const ready = text.trim().length > 0;
  return (
    <form
      data-testid="next-input-question"
      onSubmit={(e) => { e.preventDefault(); if (ready) onAnswer(q.key, text.trim()); }}
      style={{ marginTop: 10, padding: "10px 12px", border: "1px solid var(--audit-border, #e5e7eb)", borderRadius: 8, fontSize: 12.5, lineHeight: 1.6 }}
    >
      <label htmlFor={`next-${q.key}`} style={{ display: "block", fontWeight: 700, marginBottom: 2 }}>다음 질문 · {q.prompt || "물품의 재질·구성·사용 방법을 설명해 주세요."}</label>
      <div style={{ color: "var(--audit-text-muted)", marginBottom: 6 }}>
        결정트리가 남은 조건을 판단하려면 물품 설명이 필요합니다. 재질, 무엇에 끼워 쓰는지, 작동 방식처럼 눈으로 확인한 사실을 적어 주세요.
      </div>
      <textarea
        id={`next-${q.key}`}
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={disabled}
        maxLength={500}
        rows={3}
        placeholder="예: 화물차 운전실(캡)과 차대 사이에 끼워 쓰는 유압식 완충기, 강철 실린더와 피스톤 구조"
        style={{ width: "100%", boxSizing: "border-box", border: "1px solid var(--audit-border-strong, #cdd1d8)", borderRadius: 6, padding: "6px 9px", font: "inherit", fontSize: 12.5, background: "transparent", color: "inherit", resize: "vertical" }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 6 }}>
        <span style={{ color: "var(--audit-text-muted)", fontSize: 11.5, alignSelf: "center" }}>{text.length}/500</span>
        <button
          type="submit"
          disabled={disabled || !ready}
          style={{ border: "1px solid var(--audit-accent, #2563eb)", background: ready ? "var(--audit-accent, #2563eb)" : "transparent", color: ready ? "#fff" : "var(--audit-text-muted)", borderRadius: 6, padding: "4px 12px", fontSize: 12, fontFamily: "inherit", cursor: ready ? "pointer" : "default" }}
        >
          설명 넣고 다시 계산
        </button>
      </div>
    </form>
  );
}
